import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'floating-button',
  standalone: false,
  templateUrl: './floating-button.component.html',
  styleUrls: ['./floating-button.component.scss'],
})
export class FloatingButtonComponent implements OnInit {
  @Input() buttonLabel: string;
  @Input() styleBottom: number = 100; // Default value set to 100px
  @Output() buttonAction: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  action() {
    this.buttonAction.emit();
  }
}